export function urlFriendly(str: string): string {
  return str
    .replace(/ /gi, '-')
    .replace(/[^a-z0-9-]/gi, '')
    .toLowerCase();
}
